import { render, staticRenderFns } from "./ResultNews.vue?vue&type=template&id=e3024616"
import script from "./ResultNews.vue?vue&type=script&lang=ts"
export * from "./ResultNews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports